module.exports = __webpack_public_path__ + "static/media/8_The final lesson_RU.9325a18a.txt";